import { CommonError } from '../../types';
import { FETCH_LIST_PRICE_BOARD_FAILURE, FETCH_LIST_PRICE_BOARD_REQUEST, FETCH_LIST_PRICE_BOARD_SUCCESS } from './constants';
import { ListPriceBoardData } from './types';

export interface FetchListPriceBoardRequestAction {
    type: typeof FETCH_LIST_PRICE_BOARD_REQUEST;
    payload?: string; // Có thể thêm tham số filter nếu cần
}

export interface FetchListPriceBoardSuccessAction {
    type: typeof FETCH_LIST_PRICE_BOARD_SUCCESS;
    payload: ListPriceBoardData[]; // Thay bằng kiểu dữ liệu chính xác của danh sách
}

export interface FetchListPriceBoardFailureAction {
    type: typeof FETCH_LIST_PRICE_BOARD_FAILURE;
    payload: CommonError;
}

export type ListPriceBoardActions =
    | FetchListPriceBoardRequestAction
    | FetchListPriceBoardSuccessAction
    | FetchListPriceBoardFailureAction;

export const fetchListPriceBoardRequest = (payload?: string): FetchListPriceBoardRequestAction => ({
    type: FETCH_LIST_PRICE_BOARD_REQUEST,
    payload,
});

export const fetchListPriceBoardSuccess = (list: any[]): FetchListPriceBoardSuccessAction => ({
    type: FETCH_LIST_PRICE_BOARD_SUCCESS,
    payload: list,
});

export const fetchListPriceBoardFailure = (error: CommonError): FetchListPriceBoardFailureAction => ({
    type: FETCH_LIST_PRICE_BOARD_FAILURE,
    payload: error,
});
